import React from "react";
import theme from "../../../theme";
import IconStyles from "../Icon.styles";
import { IStreetlightIconProps } from "../Icon.types";

const HANGING_ICON: React.FC<IStreetlightIconProps> = (
  props: IStreetlightIconProps
) => {
  const { reported, className, type } = props;
  let { bgFill, fill } = props;

  if (!bgFill) {
    bgFill = reported
      ? theme.CE_THEME.colors.alerts.secondary
      : theme.CE_THEME.colors.brand.primary;
  }

  if (!fill) {
    fill = "#ffffff";
  }

  return (
    <IconStyles.StreetlightIcon
      id={`${type}`}
      className={`${className}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 360 360"
    >
      <circle fill={bgFill} cx="180" cy="180" r="180" />
      <g>
        <path
          fill={fill}
          d="M187.411,110.113a7.187,7.187,0,0,0-14.368,0,6.945,6.945,0,0,0,3.828,6.162h-.236v4.091h7.184v-4.091h-.236A6.946,6.946,0,0,0,187.411,110.113Z"
        />
        <path
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeWidth="6.88"
          d="M28.634,86.975c29.039,14.751,86.03,24.779,151.593,24.779,65.22,0,121.962-9.923,151.139-24.548"
        />
        <path
          fill={fill}
          d="M180.227,203.856c30.1,0,54.807,7.5,57.569,17.082a18.277,18.277,0,0,0,.276-3.043c0-10.15-8.487-19.186-21.71-25.077V146.041c0-.165-.02-.325-.025-.488,0-.117.025-.23.025-.347,0-13.719-16.178-24.84-36.135-24.84s-36.135,11.121-36.135,24.84a17.128,17.128,0,0,0,.126,1.716,18,18,0,0,0-.126,2.062v43.834c-13.223,5.891-21.71,14.927-21.71,25.077a18.277,18.277,0,0,0,.276,3.043C125.42,211.356,150.129,203.856,180.227,203.856Z"
        />
        <path
          fill="none"
          stroke={fill}
          strokeMiterlimit="10"
          strokeWidth=" 7.863"
          d="M137.711,203.856c-.306,5.642.734,12.354,3.6,20.366,9.013,25.212,17.424,48.319,38.917,48.319s30.445-22.931,38.917-48.319c2.682-8.036,3.755-14.752,3.591-20.366Z"
        />
      </g>
    </IconStyles.StreetlightIcon>
  );
};

export default HANGING_ICON;
